export default function matchField (field, entity, type) {
  const hasCustomSuffix = field.endsWith('_custom');
  const isCustom = hasCustomSuffix || type === 'custom';

  const normalizedField = hasCustomSuffix
    ? field.slice(0, -7)
    : field;

  let label;

  switch (true) {
    case field === 'host__os':
      label = 'Asset Os';
      break;

    case field === 'easeofresolution':
      label = 'Ease of Resolution';
      break;

    case field === 'status_code':
      label = 'Status Code';
      break;

    case field === 'pname':
      label = 'Param Name';
      break;

    case field === 'policyviolations':
      label = 'Policy Violations';
      break;

    case field === 'external_id':
      label = 'External Id';
      break;

    case normalizedField === 'creator_id':
      label = 'Creator';
      break;

    case field === 'create_date' && (entity !== 'workspaces'):
      label = 'Creation Date';
      break;

    case field === 'creation_time':
      label = 'Creation Time';
      break;

    case field === 'last_modified':
      label = 'Last Modified';
      break;

    case field === 'open_services':
      label = 'Open Services';
      break;

    case field === 'severity_counts':
      label = 'Important Vulnerabilities';
      break;

    case field === 'importance':
      label = 'Importance';
      break;

    case field === 'tool':
      label = 'Creator Tool';
      break;

    case field === 'command_id':
      label = 'Creator Command Id';
      break;

    case field === 'creator_command_tool':
      label = 'Creator Tool';
      break;

    case field === 'creator_command_id':
      label = 'Creator Command Id';
      break;

    case field === 'parameters':
      label = 'Parameters';
      break;

    case field === 'service__name':
      label = 'Service';
      break;

    case field === 'services_port':
      label = 'Services Port';
      break;

    case field === 'services_status':
      label = 'Services Status';
      break;

    case field === 'issuetracker':
      label = 'Issue Tracker';
      break;

    case field === 'update_date' && (entity !== 'workspaces'):
      label = 'Updated';
      break;

    case field === 'risk':
      label = 'Total Risk Score';
      break;

    case field === 'create_date' && (entity === 'workspaces'):
      label = 'Creation Date';
      break;

    case field === 'update_date' && (entity === 'workspaces'):
      label = 'Last Modified';
      break;

    case field === 'range_dates':
      label = 'Start-end date';
      break;

    case field === 'name' && (entity === 'workspaces'):
      label = 'Workspace';
      break;

    case field === 'workspace_name':
      label = 'Workspace';
      break;

    case field === 'status_history':
      label = 'Status Trace';
      break;

    case field === 'last_detected':
      label = 'Last Detected';
      break;

    case field === 'services':
      label = 'Services';
      break;

    case field === 'mac':
      label = 'Mac Address';
      break;

    case field === 'vulns':
      label = 'Vulnerabilities';
      break;

    case field === 'active' && entity === 'workspaces':
      label = 'Status';
      break;

    case field === 'group_by' && entity === 'workspaces':
      return 'Group By';

    default:
      label =
        normalizedField.charAt(0).toUpperCase() +
        normalizedField.slice(1);
  }
  return isCustom ? `${label} (Custom Field)` : label;
}
